import React from 'react';
import type { FC } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  colors,
  Container,
  Typography,
  makeStyles
} from '@material-ui/core';
import type { Theme } from 'src/theme';

interface FooterProps {
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: colors.grey[700],
    paddingTop: 25,
    paddingBottom: 25
  },
  text: {
    fontFamily: 'Poppins',
    color: colors.common.white,
  },
  browseButton: {
    marginLeft: theme.spacing(2)
  }
}));

const Footer: FC<FooterProps> = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Container maxWidth="md">
        <Typography
          variant="body2"
          align="center"
          className={classes.text}
        >
          LIBERTE ©2021
        </Typography>
        <Typography
          variant="body2"
          align="center"
          className={classes.text}
        >
          473 E. Carnegie Drive, Suite 200 San Bernardino CA 92408  
        </Typography>
      </Container>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
